import { Injectable } from '@angular/core';
import { take } from 'rxjs';
import { CONSTANTS } from '../../Constants/Constants';
import { SyncDataRequest } from '../../models/dtos';
import { CommonDataService } from '../common-data.service';
import { UserProfileService } from './user-profile.service';
import { SynchronizationApiService } from '../api/synchronization-api.service';
import { SolCalculationsService } from '../operations/sol-calculations.service';
import { CommonSynchronizationDataService } from './common-synchronization-data.service';

@Injectable({ providedIn: 'root' })
export class SyncOperationsService {

  constructor(
    private readonly commonSynchronizationService: CommonSynchronizationDataService,
    private readonly synchronizationApiService: SynchronizationApiService,
    private readonly solCalculationsService: SolCalculationsService,
    private readonly userProfileService: UserProfileService,
    private readonly commonDataService: CommonDataService
  ) {}

  synchronizeData(): void {
    const syncDataRequest = new SyncDataRequest();
    syncDataRequest.userId = this.userProfileService.userInfo?.gid ?? '';
    syncDataRequest.ratesRequest = this.commonSynchronizationService.createRatesRequest();

    if (!syncDataRequest.ratesRequest) {
      return;
    }

    this.synchronizationApiService.getSyncData(syncDataRequest)
      .pipe(take(CONSTANTS.ONE))
      .subscribe({
        next: (response) => {
          const ratesResponse = response?.rates;
          if (!ratesResponse) {
            return;
          }

          this.commonDataService.setLastSyncDate(ratesResponse.lastSyncDate);

          this.commonSynchronizationService.compareLaborRatesAndEscalationRates(
            syncDataRequest.ratesRequest,
            ratesResponse
          )
            .then((shouldRecalculate) => {
              if (shouldRecalculate) {
                return this.solCalculationsService.calculateCostsAndSellPricesWithCollections();
              }
              return undefined;
            })
            .catch((error) => {
              console.error('Sync and recalculation failed', error);
            });
        },
        error: (error) => {
          console.error('Synchronization failed', error);
        }
      });
  }
}
